<template>
  <div class="col-md-6">
    <div id="accordion" class="mgb30">
      <div class="card">
        <div class="card-header">
          <a
            class="collapsed card-link"
            data-toggle="collapse"
            href="#collapseOne"
            aria-expanded="true"
          >
            Does a proxy protect me from hackers?
            <span></span
          ></a>
        </div>
        <div id="collapseOne" class="collapse" data-parent="#accordion" style="">
          <div class="card-body">
            A proxy may add an extra layer of protection but this still doesn't mean you're 100%
            safe. The proxies we provide are public proxies, this means the proxy may be infected.
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header">
          <a class="collapsed card-link" data-toggle="collapse" href="#collapseTwo">
            For what purpose can I use these proxies?
            <span></span
          ></a>
        </div>
        <div id="collapseTwo" class="collapse" data-parent="#accordion">
          <div class="card-body">
            These proxies are public and you can use them for anything you want but some of the
            proxies can be banned on the services you want to use.
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header">
          <a class="collapsed card-link" data-toggle="collapse" href="#collapseThree">
            What is the proxy bandwidth?
            <span></span
          ></a>
        </div>
        <div id="collapseThree" class="collapse" data-parent="#accordion">
          <div class="card-body">
            By the premium datacenter proxies it is how much traffic you can send through the
            proxies, for the free proxies we don't know, if the bandwidth of the proxy is exceeded
            the proxy will probably die.
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header">
          <a class="collapsed card-link" data-toggle="collapse" href="#collapseFour">
            What is the proxy timeout?
            <span></span
          ></a>
        </div>
        <div id="collapseFour" class="collapse" data-parent="#accordion">
          <div class="card-body">
            The timeout can be anything from 50ms up to 100 seconds, but we check our proxy list
            with 10 seconds timeout.
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-6">
    <div id="accordion2" class="mgb30">
      <div class="card">
        <div class="card-header">
          <a class="collapsed card-link" data-toggle="collapse" href="#collapseFive">
            Can I scrape from this website?
            <span></span
          ></a>
        </div>
        <div id="collapseFive" class="collapse" data-parent="#accordion2">
          <div class="card-body">
            Yes you can use a proxy scraper to download the proxy list, as long as you don't harm
            our website we don't care.
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header">
          <a class="collapsed card-link" data-toggle="collapse" href="#collapseSix">
            How often does the free proxy list update?
            <span></span
          ></a>
        </div>
        <div id="collapseSix" class="collapse" data-parent="#accordion2">
          <div class="card-body">
            For free users the proxies update every 5 minutes, for
            <a href="https://proxyscrape.com/premium?ref=faq" style="text-decoration: underline"
              >premium</a
            >
            users the proxies update every 1 minute.
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header">
          <a class="collapsed card-link" data-toggle="collapse" href="#collapseSeven">
            Are these proxies always online?
            <span></span
          ></a>
        </div>
        <div id="collapseSeven" class="collapse" data-parent="#accordion2">
          <div class="card-body">
            No, this are public proxies hosted by volunteers on the internet.
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header">
          <a class="collapsed card-link" data-toggle="collapse" href="#collapseEight">
            Do you sell any proxies?
            <span></span
          ></a>
        </div>
        <div id="collapseEight" class="collapse" data-parent="#accordion2">
          <div class="card-body">
            Yes! We sell datacenter proxies in our
            <a href="https://proxyscrape.com/premium?ref=faq" style="text-decoration: underline"
              >premium</a
            >
            plan. These proxies are very fast and 24/7 online.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
